import { useProductStore } from "./useProductStore";

export const useTestCaseModal = () =>
  useProductStore((state) => ({
    isOpen: state.testCaseModal,
    openModal: state.openTestCaseModal,
    closeModal: state.closeTestCaseModal,
    type: state.type as "testCase1" | "testCase2" | "testCase3",
  }));
